module.exports = __webpack_public_path__ + "img/0x2e17c0466895e0a4e3D8CEA64F093339fA1ba279.62a031bf.png";